export default __webpack_public_path__ + "static/CodeADifference-294505866ac73fee1894011effaffca1.png";